import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, Sort } from '@angular/material';
import { PreferenceService } from 'src/app/services/preference.service';
import { LprDataService } from 'src/app/services/lpr-data.service';
import { first } from 'rxjs/operators';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { ThrowStmt } from '@angular/compiler';
import { DomSanitizer } from '@angular/platform-browser';
import { getTreeMissingMatchingNodeDefError } from '@angular/cdk/tree';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';
import { SearchLprViolationDialogComponent } from './search-lpr-violation-dialog/search-lpr-violation-dialog.component';
import * as moment from 'moment';
import { UserService } from 'src/app/services/user.service';

import {animate, state, style, transition, trigger} from '@angular/animations';
import { NzTreeHigherOrderServiceToken } from 'ng-zorro-antd';

export interface Property {
  userId: number;
  userName: any;
  id: number;
  sessionStart: any;
  sessionEnd: any;
  duration: any;
  camraGroupName: any;
  TotalScans: any;
  TotalPermitted: any;
  TotalViolations: any;
}

@Component({
  selector: 'app-shift-details',
  templateUrl: './shift-details.component.html',
  styleUrls: ['./shift-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ShiftDetailsComponent implements OnInit {

  public displayedColumns: string[] = [
    'action',
    'userName',
    'sessionStart',
    'sessionEnd',
    'duration',
    'cameraGroupName',
    'totalScans',
    'totalPermitted',
    'totalAuthorized',
    'totalExpired',
    'totalUnAuthorized',
    'totalUnpaid',
    'download'
  ];
  public displayedDetailColumns: string[] =[
    'licenceNumber'
  ]
  public dataSource = new MatTableDataSource();
  public dataSource2 = new MatTableDataSource();


  public data: any;
  public detail: any;
  public detailcount: any;
  public expandAll: boolean = false;
  public expandId: any;
  public userList: any;
  public uid: any = 0;
  public expanded: number = 0;
  public img: any;
  public eImg: any;
  public lpr: any;
  public userFilter: number = 0;
  public currentDate: any;
  public startDateFilter: any;
  public endDateFilter: any;
  public mydata: any;
  public mydetail: any;
  public uniqueArray: any;
  public uniqueArrayLength: any;
  public scans: any;
  public search: any;
  public searchDisable: boolean;
  public searchDisable2: boolean;
  public dir;
  public title: string = WebConstants.MENU_NAMES.SHIFT_DETAIL;
  public selected: {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
  public ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }
  
  searchValue: string = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  violation: number;
  Escans: any;
  Pscans: any;
  totalhits: any;

  constructor(public preferenceService: PreferenceService,
    public dialog: MatDialog,
    public userService: UserService,
    private sanitizer:DomSanitizer,
    public toaster: ToastrService,
    public lprdataservice: LprDataService,
    public excelExportDataService: ExcelExportDataService) {
      //this.getAllProperty();
      // this.LprShiftData();
      // this.getFilterData();
     }

  
    ngOnInit() {
      this.getAllUsers();
      this.currentDate = moment();
      // this.startDateFilter = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
      // this.endDateFilter = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
      this.search = "";
      this.searchDisable = true;
      this.getFilterData();

      
    }

    getAllUsers(): void {
      this.userService.getAllCommon()
        .pipe(first())
        .subscribe(response => {
          if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
            this.userList = response.data.filter(x=>x.roleName == "Patrolling Officer");
            this.uniqueArrayLength = this.userList.length;
            if(this.uniqueArrayLength == 1){
              this.userFilter = this.userList[0].userId;
            }
          } else {
            this.toaster.error(response.value, "Failed To Load Data!")
          }
        });
    }

    // ngAfterViewInit(){
    //   this.getFilterData();
    // }

    // getDetailFilterData(){
    //   if(this.search != ""){
    //     this.mydetail = this.detail.filter(x=>x.licenseNumber == this.search.trim().toLowerCase());
    //     console.log("A");
    //   }
    //   else{
    //     this.mydetail = this.detail;
    //     console.log("B");
    //   }
    // }

    clear(){
      // this.startDateFilter= '';
      // this.endDateFilter= '';
      this.search = '';
      this.getFilterData();
    }

  
  // LprShiftScan(row:any){
  //   this.scans = this.detail.filter(x=>x.patrollingSessionId == row.id && x.userId == row.userId).length;
  //   return this.scans;
  // }

  // LprShiftExpired(row:any){
  //   this.Escans = this.detail.filter(x=>x.patrollingSessionId == row.id && x.userId == row.userId && x.SearchDetail == "Expired" || x.SearchDetail == "Unpaid").length;
  //   return this.Escans;
  // }

  // LprShiftPermitted(row:any){
  //   this.Pscans = this.detail.filter(x=>x.patrollingSessionId == row.id && x.userId == row.userId && x.SearchDetail == "Permitted" || x.SearchDetail == "Alive").length;
  //   return this.Pscans;
  // }
  
  LprShiftData(payload){
    this.lprdataservice.LprShiftData(payload).pipe(first()).subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.data = response.data;
        this.getAllData();
      }
    });
  }

  AuthCount(row:any){
    let index = this.data.findIndex(x=>x.id == row.id);
    let newdata = this.data[index].data;
    if(newdata!= null){
    this.detailcount=newdata.filter(w=>w.matchedStatus == 'Authorized').length;
    }
    else{
      this.detailcount=0;
    }
    return this.detailcount;
  }

  UnauthCount(row:any){
    let index = this.data.findIndex(x=>x.id == row.id);
    let newdata = this.data[index].data;
    if(newdata!= null){
    this.detailcount=newdata.filter(w=>w.matchedStatus == 'Unauthorized').length;
    }
    else{
      this.detailcount=0;
    }
    return this.detailcount;
  }

  ExpiredCount(row:any){
    let index = this.data.findIndex(x=>x.id == row.id);
    let newdata = this.data[index].data;
    if(newdata!= null){
    this.detailcount=newdata.filter(w=>w.matchedStatus == 'Expired').length;
    }
    else{
      this.detailcount=0;
    }
    return this.detailcount;
  }

  PermittedCount(row:any){
    let index = this.data.findIndex(x=>x.id == row.id);
    let newdata = this.data[index].data;
    if(newdata!= null){
    this.detailcount=newdata.filter(w=>w.matchedStatus == 'Permitted').length;
    }
    else{
      this.detailcount=0;
    }
    return this.detailcount;
  }

  UnpaidCount(row:any){
    let index = this.data.findIndex(x=>x.id == row.id);
    let newdata = this.data[index].data;
    if(newdata!= null){
    this.detailcount=newdata.filter(w=>w.matchedStatus == 'Unpaid').length;
    }
    else{
      this.detailcount=0;
    }
    return this.detailcount;
  }

  // LprShiftPermitted(row:any){
  //   this.Pscans = this.detail.filter(x=>x.patrollingSessionId == row.id && x.userId == row.userId && x.SearchDetail == "Permitted" || x.SearchDetail == "Alive").length;
  //   return this.Pscans;
  // }
  
  LprShiftRawData(payload: any){
    this.lprdataservice.LprShiftRawData(payload.id).pipe(first()).subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.detail = response.data;
        if(this.detail.length > 0){
          this.searchDisable = false;
        }
        else{
          this.searchDisable = true;
        }
      }
    });
  }

  uniqueList(){
    this.uniqueArray = this.removeDuplicates(this.data, "userId");
    this.uniqueArrayLength = this.uniqueArray.length;
  }

  getFilterData(){
    this.LprShiftData({
      "sessionStartString": this.selected.start.format("MM-DD-YYYY"),
      "sessionEndString": this.selected.end.format("MM-DD-YYYY"),
      "licencePlateNumber": this.search.toUpperCase()
      // "sessionStart": 1641001504000,
      // "sessionEnd": 1643644812000
    });
  }

  getAllData(){
    // let startTime = Date.parse(this.selected.start);
    // let endTime = Date.parse(this.selected.end);

    // if(this.userFilter && this.selected.start && this.selected.end){
    //   this.mydata = this.data.filter(x=>x.userId == this.userFilter && Date.parse(x.sessionStart) >= startTime && Date.parse(x.sessionStart) <= endTime);
    // }
    // else if(this.userFilter && this.selected.start){
    //   this.mydata = this.data.filter(x=>x.userId == this.userFilter && Date.parse(x.sessionStart) >= startTime);
    // }
    // else if(this.selected.start && this.selected.end){
    //   this.mydata = this.data.filter(x=>Date.parse(x.sessionStart) >= startTime && Date.parse(x.sessionStart) <= endTime);
    // }
    // else if(this.selected.start){
    //   this.mydata = this.data.filter(x=>Date.parse(x.sessionStart) >= startTime);
    // }
    // else if(this.userFilter){
    //   this.mydata = this.data.filter(x=>x.userId == this.userFilter);
    // }
    if(this.userFilter){
        this.mydata = this.data.filter(x=>x.userId == this.userFilter);
        this.dataSource = new MatTableDataSource<unknown>(this.mydata);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    else{
      this.mydata = this.data;
      this.dataSource = new MatTableDataSource<unknown>(this.mydata);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    
    if(this.search && this.search != ""){
      this.mydata.forEach(row => {
        row.expanded = true;
      })
    }
    else{
      this.mydata.forEach(row => {
        row.expanded = false;
      })
    }

    if(this.mydata.length > 0){
      this.searchDisable2 = false;
    }
    else{
      this.searchDisable2 = true;
    }

  }

  sortTable(n) {
    var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
    table = document.getElementById("myTable");
    switching = true;
    this.dir = "asc"; 
    while (switching) {
      switching = false;
      rows = table.rows;
      for (i = 1; i < (rows.length - 1); i++) {
        shouldSwitch = false;
        x = rows[i].getElementsByTagName("TD")[n];
        y = rows[i + 1].getElementsByTagName("TD")[n];
        if (this.dir == "asc") {
          if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
            shouldSwitch= true;
            break;
          }
        } else if (this.dir == "desc") {
          if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        switchcount ++;      
      } else {
        if (switchcount == 0 && this.dir == "asc") {
          this.dir = "desc";
          switching = true;
        }
      }
    }
  }
  sortNumTable(n) {
    var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
    table = document.getElementById("myTable");
    switching = true;
    this.dir = "asc"; 
    while (switching) {
      switching = false;
      rows = table.rows;
      for (i = 1; i < (rows.length - 1); i++) {
        shouldSwitch = false;
        x = rows[i].getElementsByTagName("TD")[n];
        y = rows[i + 1].getElementsByTagName("TD")[n];
        if (this.dir == "asc") {
          if (Number(x.innerHTML) > Number(y.innerHTML)) {
            shouldSwitch= true;
            break;
          }
        } else if (this.dir == "desc") {
          if (Number(x.innerHTML) < Number(y.innerHTML)) {
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        switchcount ++;      
      } else {
        if (switchcount == 0 && this.dir == "asc") {
          this.dir = "desc";
          switching = true;
        }
      }
    }
  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
}

    getImg(detailrow: any){
      this.eImg = detailrow.image;
      this.lpr = detailrow.LicensePlate;
    }

    getEmail(emailImg: any){
      return this.sanitizer.bypassSecurityTrustResourceUrl(emailImg);
    }

    toggleOn(row){
      row.expanded = !row.expanded;
      this.expandId = this.mydata.findIndex(x=>x.id == row.id);
    }

    toggleOff(row){
      row.expanded = false;
    }

    // applyFilter(event: Event) {
    //   const filterValue = (event.target as HTMLInputElement).value;
    //   this.dataSource.filter = filterValue.trim().toLowerCase();
    // }

    excelSheetDownload() {
      let dataForExcel = [];
  
      this.mydata.forEach((row: any) => {
        //console.log(row);
        let rowData: any = [row.userName, new Date(row.sessionStart).toLocaleString(), row.sessionEnd==null ? "":new Date(row.sessionEnd).toLocaleString(),row.duration,row.cameraGroupName,row.data==null? 0: row.data.length, this.PermittedCount(row), this.AuthCount(row), this.ExpiredCount(row), this.UnauthCount(row), this.UnpaidCount(row)]
        dataForExcel.push(rowData);
      });
  
      let reportData = {
        title: this.title,
        data: dataForExcel,
        headers: ['Name', 'Shift Started', 'Shift Ended','Duration','Camera Group','Total Scans', 'Permitted', 'Authorized', 'Expired', 'Unauthorized', 'Unpaid']
      };
  
      this.excelExportDataService.exportExcel(reportData)
    }

    excelSheetDetailDownload(obj){
      let dataForExcel = [];
      let i = this.mydata.findIndex(x=>x.id == obj.id);
      let ddata;
      if(this.search && this.search != ""){
        ddata = this.mydata[i].data.filter(Y=>Y.licenceNumber == this.search);
      }
      else{
        ddata = this.mydata[i].data;
      }
        ddata.forEach((row: any) => {
          let rowData: any = [
            row.licenceNumber,
            row.state,
            new Date(row.createdDate).toLocaleString(),
            row.matchedStatus,
            row.cameraIdentifier
          ]
          dataForExcel.push(rowData);
          
        });    
  
      let reportData = {
        title: 'Session Details',
        data: dataForExcel,
        headers: ['License Plate', 'State', 'Scanned on','Search Detail','Camera']
      };
  
      this.excelExportDataService.exportExcel(reportData)
    }

    viewDetail(data: any): void {
      const dialogRef = this.dialog.open(SearchLprViolationDialogComponent, {
        //height: "100vh",
        maxHeight: "150vh",
        data: data
      });
    }

    downloadPDF(data: any): void {
        // console.log(data.emailHtml);
        var tab = window.open('about:blank', '_blank');
        tab.document.write(data.emailHtml); // where 'html' is a variable containing your HTML
        tab.document.close(); // to finish loading the page
    }

  }

